import {
  TTabKey,
} from './audit-trail.ts';

const tabs: Record<TTabKey, string> = {
  settings: 'Einstellungen',
  events: 'Ereignisse',
};

export default {
  tabs,
};
